/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { TileFragmentDoc } from '../Tile/Tile.generated'
export type PanelFragment = {
  __typename?: 'Panel'
  title?: string | null
  collapsible?: boolean | null
  tiles: Array<{
    __typename?: 'Tile'
    title?: string | null
    collapsible?: boolean | null
    caption?: string | null
    allowContentCopy?: boolean | null
    allowContentDownload?: boolean | null
    filters: Array<
      | {
          __typename: 'BooleanField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          state?: boolean | null
          localEdited?: boolean | null
          localState?: boolean | null
        }
      | {
          __typename: 'DateField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          date?: any | null
          localEdited?: boolean | null
          localDate?: string | null
        }
      | {
          __typename: 'DateTimeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          dateTime?: any | null
          localEdited?: boolean | null
          localDateTime?: string | null
        }
      | {
          __typename: 'DownloadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          selection?: {
            __typename?: 'SelectField'
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          } | null
        }
      | {
          __typename: 'MultiSelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        }
      | {
          __typename: 'NumberField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          value?: number | null
          localEdited?: boolean | null
          localValue?: number | null
        }
      | {
          __typename: 'NumberRangeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
        }
      | {
          __typename: 'SelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        }
      | {
          __typename: 'TextField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          text?: string | null
          localEdited?: boolean | null
          localText?: string | null
        }
      | {
          __typename: 'UploadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          overrideAppId?: string | null
          templateId?: string | null
          entityId?: string | null
        }
    >
    shallowContent?:
      | { __typename?: 'Chart' }
      | { __typename?: 'DataTemplate' }
      | { __typename?: 'Form'; id: string }
      | { __typename?: 'Metric'; id: string }
      | { __typename?: 'Table'; id: string }
      | { __typename?: 'VegaLiteChart'; id: string }
      | null
  }>
}

export const PanelFragmentDoc = gql`
  fragment Panel on Panel {
    title
    collapsible
    tiles {
      ...Tile
    }
  }
  ${TileFragmentDoc}
`
